export * from './components';
export * from '@omegagrid/tree';
export * from '@omegagrid/toolbar';
export * from '@reporting/rp-app-host';

import { ComponentId, dom } from "@omegagrid/core";
import { AppComponent, AppHost, Application, Container, parseComponentId, AppInfo } from '@reporting/rp-app-host';
import { componentFactories } from './factories';
import { MDMSearchProvider } from './searchProvider';

export class MdmApplication extends Application {

	async register(container: Container) {
		super.register(container);
		container.services.register('mdm');
		container.commands.registerProvider(new MDMSearchProvider());
	}

	async init(container: Container) {
		super.init(container);
		container.services.register('etl');
		container.services.register('accounting');
	}

	createComponent(id: ComponentId): AppComponent|Promise<AppComponent> {
		const parsedId = parseComponentId(id);
		const factory = componentFactories.get(parsedId.id as string || parsedId.type);
		if (!factory) return null;
		return factory(this, parsedId);
	}
}
